var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27275"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8937",
    style: {
      fill: "#fff"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Outline / Status /Info-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1a1 1 0 1 1-1-1 1 1 0 0 1 1 1z",
    transform: "translate(10.947 8.206)",
    style: {
      fill: "#e2222e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path",
    d: "M.75 0a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5A.75.75 0 0 1 .75 0z",
    transform: "translate(11.197 11.956)",
    style: {
      fill: "#e2222e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.947 18.528a69.667 69.667 0 0 1-7.713-.43A2.511 2.511 0 0 1 .211 14.6l.09-.207A76.1 76.1 0 0 1 7.244 1.831l.432-.631a2.75 2.75 0 0 1 4.541 0l.432.633a76.169 76.169 0 0 1 6.944 12.563l.09.207a2.511 2.511 0 0 1-2.024 3.5 69.649 69.649 0 0 1-7.712.425zm0-17.028a1.234 1.234 0 0 0-1.032.545l-.432.632a74.683 74.683 0 0 0-6.807 12.315l-.09.207a1.011 1.011 0 0 0 .814 1.409 68.173 68.173 0 0 0 7.546.421 68.173 68.173 0 0 0 7.546-.421 1.011 1.011 0 0 0 .815-1.408l-.09-.207A74.551 74.551 0 0 0 11.41 2.677l-.432-.632A1.232 1.232 0 0 0 9.947 1.5z",
    transform: "translate(2 3)",
    style: {
      fill: "#e2222e"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertRed);
export default __webpack_public_path__ + "static/media/alert-red.5cd5d4abbadbab0fb9f6d552777ccd6e.svg";
export { ForwardRef as ReactComponent };